export class VoiceResponse {
    constructor(question, answer, audioData) {
        this.question = question;
        this.answer = answer;
        this.audioData = audioData;
    }

    static fromJSON(json) {
        return new VoiceResponse(
            json.question,
            json.answer,
            json.audioData
        );
    }

    playAudio() {
        if (!this.audioData || this.audioData.length === 0) {
            console.warn('No audio data available');
            return null;
        }

        try {
            // The audioData comes as a base64 string or array of bytes from JSON
            let uint8Array;

            if (typeof this.audioData === 'string') {
                // If it's a base64 string, decode it
                const binaryString = atob(this.audioData);
                uint8Array = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    uint8Array[i] = binaryString.charCodeAt(i);
                }
            } else if (Array.isArray(this.audioData)) {
                // If it's an array of numbers, convert to Uint8Array
                uint8Array = new Uint8Array(this.audioData);
            } else {
                // Already a typed array
                uint8Array = new Uint8Array(this.audioData);
            }

            // Create a Blob from the byte array (MP3 format)
            const blob = new Blob([uint8Array], { type: 'audio/mpeg' });

            // Create an object URL from the Blob
            const audioUrl = URL.createObjectURL(blob);

            // Create and play the audio element
            const audio = new Audio(audioUrl);

            // Cleanup the object URL after playback
            audio.addEventListener('ended', () => {
                URL.revokeObjectURL(audioUrl);
            });

            audio.addEventListener('error', (e) => {
                console.error('Audio playback error:', e);
                URL.revokeObjectURL(audioUrl);
            });

            audio.play().catch(error => {
                console.error('Error playing audio:', error);
                URL.revokeObjectURL(audioUrl);
            });

            return audio;
        } catch (error) {
            console.error('Error creating audio from byte array:', error);
            return null;
        }
    }
}
